<template>
    <div class="datagrid-wrapper access-group-removal">
        <div class="row">
            <div class="col-md-12">
                <h2>Last 10 removals</h2>
                <button :disabled="disableRefreshButton" v-on:click="getRemovals();" class="btn btn-xs btn-primary">
                    <i :class="'fa fa-refresh ' + (spin ? ' fa-spin' : '') "></i> Refresh
                </button>
            </div>
            <div data-type="grid" class="col-md-12">
                <table class="datagrid table access-group-removal-list">
                    <thead>
                        <tr>
                            <th><h4>ID </h4></th>
                            <th><h4>Created At</h4></th>
                            <th><h4>Requested By</h4></th>
                            <th><h4>Completion</h4></th>
                            <th><h4>Total Count</h4></th>
                            <th><h4>Success Count</h4></th>
                            <th><h4>Fail Count</h4></th>
                            <th><h4>Finished At</h4></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="request in response.data" v-bind:key="request.id">
                            <td>{{ request.id }}</td>
                            <td>{{ formatDateTime(request.created_at) }}</td>
                            <td>{{ request.user.email }}</td>
                            <td class="text-center">{{ request.percentage }}%</td>
                            <td class="text-center">{{ request.total_count }}</td>
                            <td class="text-center">{{ request.success_count }}</td>
                            <td class="text-center">{{ request.fail_count }}</td>
                            <td>{{ formatDateTime(request.finished_at) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import {EventBus} from "../../EventBus";
import axios from 'axios';
import dayjs from "dayjs";

export default {
        name: "ToolRemovalTableComponent",
        props: {
            url: {
                required: true
            }
        },
        data: function() {
          return {
              dateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
              response: {},
              spin: false,
              disableRefreshButton: false,
          }
        },
        mounted() {
            this.getRemovals();
            EventBus.on('refresh-removal-table', this.getRemovals);
        },
        methods: {
            getRemovals: async function() {
                this.spin = true;
                this.disableRefreshButton = true;

                const {data} = await axios.get(this.url);

                this.response = data
                this.spin = false;
                this.disableRefreshButton = false;
            },
            formatDateTime(dateObj){
                if(! dayjs(dateObj).isValid()){
                    return '-'
                }
                return dayjs(dateObj).format(this.dateTimeFormat) + " (UTC)"
            }
        }
    }
</script>

<style scoped>
.access-request-list > tbody > tr > td:not(:last-child) {
    padding-right: 40px;
}


.search-input {
    position: absolute;
    top: 0;
    right: 0;
    outline: none;
    height: 30px;
    margin: 0;
    z-index: 10;
    font-family: inherit;
    border-radius: 22px;
    color: #babfbf;
    box-shadow: none;
    border: 1px solid #979ca2;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.6;
    width: 250px;
}

.search-input__button {
    background: #fff;
    filter: alpha(opacity=0);
    opacity: 0;
    color: transparent;
    border: none;
    outline: none;
    width: 25px;
}

.search-form_wrapper {
    margin-left: 15px;
}

.datagrid-wrapper .search-form-mask.open {
    width: 250px;
}


</style>
